import { Link, useLocation } from 'react-router-dom';
import { AppIcon, WindowsLogo } from './AppIcon';
import { initials, type DesktopItem } from './items';

/**
 * Bottom dock: Windows-style Start button first, then pinned apps, then OS pages.
 * Floating and centred like the mac dock; hover labels; a small line marks the active page.
 */
export function Dock({ apps, system, startOpen, onToggleStart, userName, onUser }: {
  apps: DesktopItem[]; system: DesktopItem[]; startOpen: boolean; onToggleStart: () => void; userName?: string; onUser: () => void;
}) {
  const { pathname } = useLocation();
  return (
    <nav className="dk-dock" aria-label="Dock">
      <button type="button" className="dk-item dk-start" data-label="Start" data-open={startOpen ? '1' : '0'} aria-expanded={startOpen} aria-haspopup="dialog" onClick={onToggleStart}>
        <WindowsLogo />
      </button>
      {apps.length > 0 && <span className="dk-sep" />}
      {apps.map((a) => (
        <a key={a.id} className="dk-item" href={a.href} data-label={a.name} aria-label={a.name}><AppIcon item={a} size={38} /></a>
      ))}
      <span className="dk-sep" />
      {system.map((s) => (
        <Link key={s.id} to={s.to!} className="dk-item" data-label={s.name} aria-label={s.name} data-active={pathname === s.to ? '1' : '0'}><AppIcon item={s} size={38} /></Link>
      ))}
      <span className="dk-sep" />
      <button type="button" className="dk-item" data-label={userName ?? 'Account'} aria-label="Account" onClick={onUser}>
        <span className="dk-avatar">{initials(userName ?? '?')}</span>
      </button>
    </nav>
  );
}
